import API from "../../../../app/api";

export const trackOrderById = async (trackingId) => {
    const res = await API.get(
        `/services/track/shipments?trackingId=${trackingId}`
    );

    // API failed (real error)
    if (res.data?.status !== 200) {
        return null;
    }

    try {
        const parsed = JSON.parse(res.data.data?.remarks || "{}");
        return parsed?.data || null;
    } catch {
        return false;
    }
};
